export default __webpack_public_path__ + "static/rrc-template-34e88b7ab1ff57489e2154335a437d6c.mp4";